"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.systemMarginEnabledReducer = void 0;
var _actionTypes = require("../actionTypes");
var systemMarginEnabledReducer = exports.systemMarginEnabledReducer = function systemMarginEnabledReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
  var action = arguments.length > 1 ? arguments[1] : undefined;
  switch (action.type) {
    case _actionTypes.RECEIVE_SYSTEM_MARGIN_ENABLED:
      return action.payload.systemMarginEnabled;
    default:
      return state;
  }
};